/**
 * Templates for the `QRCode` input type, by theme. The bundle injects them under whatever
 * template prefixes the host app uses (plain pict-section-form or the HeadLight Bulma themes).
 *
 * Buttons carry only the input hash; the value is read by the provider, never put into markup.
 */

const _EditTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input" {~D:Record.Macro.ControlAttr~}>
	<label class="hlqr-input-label" for="HLQR-TEXT-{~D:Record.Macro.RawHTMLID~}">{~D:Record.Name~}</label>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-controls">
			<input type="text" class="hlqr-input-text" id="HLQR-TEXT-{~D:Record.Macro.RawHTMLID~}" data-headlight-qr-pick="{~D:Record.Hash~}" autocomplete="off" placeholder="Scan or type a code" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
			<div class="hlqr-input-buttons" id="HLQR-BUTTONS-{~D:Record.Macro.RawHTMLID~}">
				<button type="button" class="hlqr-input-button" data-hlqr-action="Scan" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-scan')">Scan</button>
				<button type="button" class="hlqr-input-button" data-hlqr-action="Generate" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-generate')">New code</button>
				<button type="button" class="hlqr-input-button" data-hlqr-action="Print" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-print')">Print label</button>
			</div>
			<div class="hlqr-input-message" id="HLQR-MESSAGE-{~D:Record.Macro.RawHTMLID~}" aria-live="polite"></div>
		</div>
	</div>
</div>
`;

const _ReadTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input hlqr-input--read" {~D:Record.Macro.ControlAttr~}>
	<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
	<span class="hlqr-input-label">{~D:Record.Name~}</span>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-controls">
			<div class="hlqr-input-value" id="HLQR-VALUE-{~D:Record.Macro.RawHTMLID~}"></div>
			<div class="hlqr-input-buttons" id="HLQR-BUTTONS-{~D:Record.Macro.RawHTMLID~}">
				<button type="button" class="hlqr-input-button" data-hlqr-action="Print" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-print')">Print label</button>
			</div>
		</div>
	</div>
</div>
`;

const _PrintTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input hlqr-input--print" {~D:Record.Macro.ControlAttr~}>
	<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
	<span class="hlqr-input-label">{~D:Record.Name~}</span>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-value" id="HLQR-VALUE-{~D:Record.Macro.RawHTMLID~}"></div>
	</div>
</div>
`;

/**
 * @param {string} pTemplate
 * @return {Array<{ HashPostfix: string, DefaultInputExtensions: Array<string>, Template: string }>}
 */
function forInputType(pTemplate)
{
	return [ '-Template-Input-InputType-QRCode', '-VerticalTemplate-Input-InputType-QRCode' ].map((pPostfix) =>
		({ HashPostfix: pPostfix, DefaultInputExtensions: [ 'HeadlightQR-Input' ], Template: pTemplate }));
}

module.exports =
{
	Edit: forInputType(_EditTemplate),
	Read: forInputType(_ReadTemplate),
	Print: forInputType(_PrintTemplate),
};
